import { FC } from "react";

import { IEventSuggestedLocation } from "Bands/types";
import { Spacer } from "shared/layout";
import { BoldText, SmallText, MutedText } from "shared/styles";
import { DateFormat, formatDateTime } from "shared/utils";

interface Props extends IEventSuggestedLocation {
  dateFormat: DateFormat;
}

export const SuggestedLocation: FC<Props> = ({ location, secondaryText, event, dateFormat }) => (
  <Spacer size="xxs">
    <BoldText>{location}</BoldText>
    {secondaryText && <SmallText as={MutedText}>{secondaryText}</SmallText>}
    {event && (
      <SmallText as={MutedText}>
        <BoldText>
          Used in: {event.title} - {formatDateTime(event.date, { dateOnly: true, dateFormat })}
        </BoldText>
      </SmallText>
    )}
  </Spacer>
);
